import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ChangePasswordPage() {
  const { refresh, logout } = useAuth();
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (form.new_password !== form.confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/change-password", {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      toast.success("Password updated");
      await refresh();
    } catch (error) {
      toast.error(apiError(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#EEF2F8] p-6">
      <form
        onSubmit={submit}
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 okn-rise"
        data-testid="change-password-form"
      >
        <KeyRound className="text-cyan-600" />
        <h1 className="mt-4 font-display text-2xl font-semibold">Set a new password</h1>
        <p className="mt-2 text-sm text-slate-600">
          The bootstrap password must be changed before you continue.
        </p>
        <div className="mt-6 space-y-4">
          {[
            ["current_password", "Current password"],
            ["new_password", "New password"],
            ["confirm", "Confirm new password"],
          ].map(([key, label]) => (
            <div key={key}>
              <Label className="mono text-[11px] uppercase tracking-wider text-slate-600">
                {label}
              </Label>
              <Input
                data-testid={`cp-${key.replace("_", "-")}-input`}
                type="password"
                value={form[key]}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                className="mt-2 border-slate-200 bg-[#EEF2F8] text-slate-900"
                required
              />
            </div>
          ))}
        </div>
        <Button
          data-testid="cp-submit-button"
          disabled={busy}
          className="mt-6 h-11 w-full rounded-full bg-cyan-500 text-[#04121a] hover:bg-cyan-400"
        >
          {busy ? <Loader2 className="animate-spin" size={17} /> : "Update password"}
        </Button>
        <button
          type="button"
          onClick={logout}
          data-testid="cp-logout-button"
          className="mono mt-4 w-full text-center text-xs uppercase tracking-wider text-slate-500 hover:text-slate-900"
        >
          Sign out
        </button>
      </form>
    </div>
  );
}
